import React from "react";
import Alert from "@material-ui/lab/Alert";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import api from "../services/api";
import { hasPermission } from "../utils/userPermissions";

export function useMetaConnectionHealth(companyId) {
  const [health, setHealth] = React.useState({ records: [], error: false });
  React.useEffect(() => {
    let active = true, busy = false;
    setHealth({ records: [], error: false });
    if (!companyId) return undefined;
    const update = async () => {
      if (busy || document.hidden) return;
      busy = true;
      try {
        const { data } = await api.get("/meta-cloud/health");
        if (active) setHealth({ records: Array.isArray(data) ? data : [], error: false });
      } catch {
        if (active) setHealth(previous => ({ ...previous, error: true }));
      } finally { busy = false; }
    };
    update();
    const timer = setInterval(update, 30000);
    document.addEventListener("visibilitychange", update);
    return () => { active = false; clearInterval(timer); document.removeEventListener("visibilitychange", update); };
  }, [companyId]);
  return health;
}
export function metaHealthProblem(record) {
  if (record.status === "blocked" || record.status === "credentials") return record.status;
  if (record.status === "unavailable") return "unavailable";
  if (!record.checkedAt || Date.now() - new Date(record.checkedAt).getTime() > 10 * 60000) return "stale";
  return null;
}
export default function MetaConnectionAlert({ health, user }) {
  const problems = health.records.filter(metaHealthProblem);
  const recovered = health.records.filter(r => !metaHealthProblem(r) && r.recoveredAt && Date.now() - new Date(r.recoveredAt).getTime() < 5 * 60000);
  if (!problems.length && !recovered.length && !health.error) return null;
  return <div style={{ flexShrink: 0 }}>
    {problems.map(record => {
      const problem = metaHealthProblem(record);
      const text = problem === "blocked" ? "A Meta bloqueou o acesso à API. O atendimento pode estar interrompido. O administrador deve conferir os avisos e a confirmação da conta na Meta."
        : problem === "credentials" ? "A Meta recusou a credencial da conexão. O administrador deve conferir o token de acesso."
        : problem === "stale" ? "A verificação de acesso à API está pendente ou desatualizada."
        : "Não foi possível confirmar o acesso à API. Isso não confirma um bloqueio da Meta.";
      return <Alert key={record.id} role="alert" severity={problem === "blocked" || problem === "credentials" ? "error" : "warning"}
        action={hasPermission(user, "connections") ? <Button color="inherit" component={Link} role="link" to="/connections">Conexões</Button> : undefined}>
        <strong>{record.name}: </strong>{text}
        {record.checkedAt && <small style={{ display: "block" }}>Verificado em {new Date(record.checkedAt).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })} (São Paulo).</small>}
      </Alert>;
    })}
    {recovered.map(record => <Alert key={`recovered-${record.id}`} severity="success" role="status"><strong>{record.name}: </strong>Acesso à API restabelecido. Confirme o atendimento com uma nova conversa de teste.</Alert>)}
    {health.error && <Alert severity="warning" role="alert">Não foi possível atualizar o monitor da API oficial. Os dados anteriores podem estar desatualizados.</Alert>}
  </div>;
}
